module.exports = __webpack_public_path__ + "img/category__2.8b593ef0.svg";